// Admin "Purchase" page: the purchase manager's Purchase page (the same
// PurchasePanel and data as PurchaseManagerDashboard.js) under the admin's own
// top menu. It opens on the admin's Purchase Approvals page
// (AdminPurchaseApprovalsView) in place of the request list, which is only
// reached from that page's cards / "View All Purchases". The older Purchase
// Management page stays at /purchase ("Purchases" in the menu).
import React, { useEffect, useRef, useState } from 'react';
import PurchasePanel from '../../components/dashboard/purchase/PurchasePanel';
import useFixedHeaderOverlap from '../../components/adminDailySchedule/useFixedHeaderOverlap';
import { getUserBalagruhas, getAllPurchaseRequests } from '../../api';
import { useRBAC } from '../../contexts/RBACContext';
import showToast from '../../utils/toast';
// Same page font / background as the purchase manager's page (.pm-home)
import '../../components/dashboard/PurchaseManagerHome.css';

export default function AdminPurchasePage() {
    const pageRef = useRef(null);
    const headerOverlap = useFixedHeaderOverlap(pageRef);
    const { hasPermission, isLoading: rbacLoading, permissions } = useRBAC();

    const [balagruhas, setBalagruhas] = useState([]);
    const [purchaseData, setPurchaseData] = useState([]);

    const permissionsLoaded = Object.keys(permissions || {}).length > 0;
    const can = (moduleName, actionName = 'Read') => {
        if (rbacLoading || !permissionsLoaded) return false;
        if (actionName.toLowerCase() === 'read') {
            return hasPermission(moduleName, 'Read') || hasPermission(moduleName, 'Manage');
        }
        return hasPermission(moduleName, actionName);
    };

    const fetchBalagruhas = async () => {
        try {
            const response = await getUserBalagruhas();
            const list = Array.isArray(response?.data) ? response.data : [];
            setBalagruhas(list.filter((b) => b._id !== 'STOCK'));
        } catch (error) {
            showToast('Error fetching balagruha', 'error');
            setBalagruhas([]);
        }
    };

    const fetchPurchases = async () => {
        try {
            const response = await getAllPurchaseRequests({ limit: 1000 });
            const requests = response?.success ? response.data?.requests || [] : [];
            setPurchaseData([...requests].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)));
        } catch (error) {
            setPurchaseData([]);
        }
    };

    useEffect(() => {
        fetchBalagruhas();
        fetchPurchases();
    }, []);

    return (
        <div
            ref={pageRef}
            className="pm-home adm-purchase-page w-full"
            style={{ paddingTop: 16 + headerOverlap, '--adm-purchase-header-overlap': `${headerOverlap}px` }}
        >
            <PurchasePanel
                balagruhas={balagruhas}
                purchaseData={purchaseData}
                canCreate={can('Purchase Management', 'Create')}
                canManageShop={can('Shop Management', 'Manage')}
                onRequestCreated={fetchPurchases}
                productApprovalMode="admin"
            />
        </div>
    );
}
